import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export type LivePhotoIconProps = CreateIconComponentProps;

export const LivePhotoIcon: React.FC<LivePhotoIconProps> = ({
  title = 'LivePhoto',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent viewBox={viewBox} title={title} {...rest} fill="none">
    <>
      <circle
        cx="12"
        cy="12"
        r="1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <circle
        cx="12"
        cy="12"
        r="5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15.9 20.11v.01M19.04 17.61v.01M20.77 14v.01M20.77 10v.01M19.04 6.39v.01M15.9 3.89v.01M12 3v.01M8.1 3.89v.01M4.96 6.39v.01M3.23 10v.01M3.23 14v.01M4.96 17.61v.01M8.1 20.11v.01M12 21v.01"
      />
    </>
  </CreateIconComponent>
);

export default LivePhotoIcon;
